import { createBrowserHistory, createMemoryHistory } from 'history'
import { isIFrame } from '../utils/isIFrame'
import { pwaMediaQueryMatch } from '../utils/isPwa'

// eslint-disable-next-line no-restricted-properties
const windowUrl = () => window.location.pathname + window.location.search + window.location.hash

let historyInstance =
  pwaMediaQueryMatch.matches && isIFrame()
    ? createMemoryHistory({ initialEntries: [windowUrl()] })
    : createBrowserHistory()

;(window as any).hist = historyInstance

export const useCustomHistory = () => {
  return historyInstance
}

export const getHistoryInstance = useCustomHistory

export const getLocation = () => getHistoryInstance().location

export const getLocationUrl = () => {
  const { location } = getHistoryInstance()
  // eslint-disable-next-line no-restricted-properties
  const origin = window.location.origin
  const url = new URL('', origin)
  url.pathname = location.pathname
  url.hash = location.hash
  url.search = location.search
  return url
}
